import { useState } from "react";
import { siteContent } from "../content/loadContent";
import { PageCopy, PageIndex, PageMedia } from "../components/site/PagePrimitives";
import "./pages.css";

export function JourneyPage() {
  const [active, setActive] = useState(1);

  return (
    <article className={`experience-page page-journey journey-state-${active}`} aria-labelledby="journey-title">
      <PageMedia src="/assets/athlete/journey-depth.webp" alt="" className="page-media--journey" />
      <PageIndex number="02" label="JOURNEY" />
      <PageCopy className="journey-copy">
        <p className="page-kicker">EVERY STEP COUNTS</p>
        <h1 id="journey-title">成长不是直线，<br />但每一步都在向前。</h1>
      </PageCopy>
      <ol className="milestone-list" aria-label="成长里程碑">
        {siteContent.growth.map((item, index) => (
          <li key={`${item.date}-${item.caption}`}>
            <button
              type="button"
              className={active === index ? "is-active" : ""}
              onClick={() => setActive(index)}
              onMouseEnter={() => setActive(index)}
              onFocus={() => setActive(index)}
              aria-pressed={active === index}
            >
              <strong>{item.date.split(" ")[0]}</strong>
              <span>{item.caption}</span>
              <small>{item.place}</small>
            </button>
          </li>
        ))}
      </ol>
      <p className="journey-note">选择一个年份，让画面跟着成长向前。</p>
    </article>
  );
}
